<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '16px 36px', height: '100%' }" :style="{ height: '100%' }">
    <a-form-model :layout="'inline'">
      <a-row>
        <a-col :span="6">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
            <a-tree-select
              :tree-data="zoneTreeData"
              v-model="query.zoneId"
              style="width: 250px"
              :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择片区"
              :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
              show-search
              treeNodeFilterProp="title"
              allowClear
            ></a-tree-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日期" style="display: flex">
            <a-radio-group :value="selectDay" @change="changeRadio" button-style="solid">
              <a-radio-button value="year">年份</a-radio-button>
              <a-radio-button value="quarter">季度</a-radio-button>
              <a-radio-button value="month">月份</a-radio-button>
              <a-radio-button value="other">其他</a-radio-button>
            </a-radio-group>

            <a-range-picker
              :placeholder="['开始日期', '截止日期']"
              :allowClear="false"
              v-model="query.balanceYear"
              :format="['YYYY-MM-DD', 'YYYY-MM-DD']"
              :valueFormat="'YYYY-MM-DD'"
              :mode="['date', 'date']"
              v-if="selectDay == 'other'"
            />

            <a-date-picker
              v-else
              placeholder="请选择日期"
              :allowClear="false"
              v-model="query.balanceYear"
              :format="selectFormat"
              :mode="selectMode"
              :open="open"
              @openChange="openChange"
              @panelChange="panelChange"
            />
            <a-select
              v-if="selectDay == 'quarter'"
              style="width: 120px; margin-left: 10px"
              v-model="queryQuarter"
            >
              <a-select-option value="第一季度">第一季度</a-select-option>
              <a-select-option value="第二季度">第二季度</a-select-option>
              <a-select-option value="第三季度">第三季度</a-select-option>
              <a-select-option value="第四季度">第四季度</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item>
            <a-button type="primary" @click="queryList">查询</a-button>
            <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
            <a-button type="primary" style="margin-left: 8px" @click="handleExport" :loading="confirmLoading">导出</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <a-spin :spinning="confirmLoading" v-if="list.length > 0">
      <table class="gridtable" v-for="item in list" :key="item.id">
        <tr>
          <td colspan="1" class="tableName">时间</td>
          <td colspan="1" class="tableName">片区</td>
          <td colspan="5" class="tableName">分析情况</td>
        </tr>
        <tr>
          <td rowspan="9" class="tableName">{{ item.balanceYear }}</td>
          <td rowspan="9" class="tableName">{{ item.zoneName }}</td>

          <td rowspan="9" class="tableName">
            供水量
            <br />
            <span class="blueFont">{{ item.waterSupply }}</span
            >( m³)
          </td>
          <td rowspan="4" class="tableName">
            合法用水量
            <br />
            <span class="blueFont">{{ item.legalWaterConsumption }}</span> ( m³)
          </td>
          <td rowspan="2" class="tableName">
            收费合法用水量
            <br />
            <span class="blueFont">{{ item.legalFees }}</span> ( m³)
          </td>
          <td class="tableCol">
            收费已计量用水量
            <br />
            <span class="blueFont">{{ item.chargeMeasured }}</span> ( m³)
          </td>
          <td rowspan="2" class="tableName">
            收益水量
            <br />
            <span class="blueFont"> {{ item.revenueWaterVolume }}</span> ( m³)
          </td>
        </tr>
        <tr>
          <td class="tableCol">
            收费未计量用水量
            <br />
            <span class="blueFont">{{ item.chargeNotMeasured }}</span
            >( m³)
          </td>
        </tr>
        <tr>
          <td rowspan="2" class="tableName">
            未收费合法用水量
            <br />
            <span class="blueFont"> {{ item.legalFeesNotCharged }}</span> ( m³)
          </td>
          <td class="tableCol">
            未收费已计量用水量
            <br />
            <span class="blueFont"> {{ item.notChargeMeasured }}</span
            >( m³)
          </td>
          <td rowspan="7" class="tableName">
            无收益水量
            <br />
            <span class="blueFont"> {{ item.notRevenueWaterVolume }}</span
            >( m³)
          </td>
        </tr>
        <tr>
          <td class="tableCol">
            未收费未计量用水量
            <br />
            <span class="blueFont">{{ item.notChargeNotMeasured }}</span
            >( m³)
          </td>
        </tr>

        <tr>
          <td rowspan="5" class="tableName">
            漏损水量
            <br />
            <span class="blueFont"> {{ item.leakageWater }} </span>(m³)
          </td>
          <td rowspan="2" class="tableName">
            表观漏损
            <br />
            <span class="blueFont">{{ item.apparentLeakage }}</span> ( m³)
          </td>
          <td class="tableCol">
            非法用水量
            <br />
            <span class="blueFont"> {{ item.illegal }}</span
            >( m³)
          </td>
        </tr>
        <tr>
          <td class="tableCol">
            表计误差损失水量
            <br />
            <span class="blueFont"> {{ item.meterErrorLoss }}</span
            >( m³)
          </td>
        </tr>
        <tr>
          <td rowspan="3" class="tableName">
            真实漏损
            <br />
            <span class="blueFont">{{ item.trueLeakage }} </span>( m³)
          </td>
          <td class="tableCol">
            主干管漏失水量
            <br />
            <span class="blueFont"> {{ item.mainPipeLeakage }}</span
            >( m³)
          </td>
        </tr>
        <tr>
          <td class="tableCol">
            蓄水池漏失和溢流水量
            <br />
            <span class="blueFont"> {{ item.reservoirLeakage }}</span
            >( m³)
          </td>
        </tr>
        <tr>
          <td class="tableCol">
            支管段漏失水量
            <br />
            <span class="blueFont"> {{ item.branchPipeLeakage }}</span
            >( m³)
          </td>
        </tr>
      </table>
    </a-spin>
    <a-empty v-else style="margin-top: 50px" />
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { baseMixin } from '@/store/app-mixin'
import moment from 'moment'
import axios from 'axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'

export default {
  name: 'WaterAnalysis',
  components: {},
  data() {
    return {
      zoneId: '',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      treeDefaultExpandedKeys: [], //默认展开的树节点
      query: {
        balanceYear: '',
        zoneId: '',
      },
      open: false,
      record: {},
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      url: '/pipe-network/zone_water_balances/page',
      list: [],
      zoneTreeData: [], // 片区选项
      queryQuarter: '第一季度',
      selectFormat: 'YYYY',
      selectMode: 'year',
      open: false,
      selectDay: 'year',
      record: {},
      confirmLoading: false,
    }
  },
  watch: {
    zoneTreeData(val) {
      this.chuli(val)
    },
    selectDay(val) {
      if (val == 'other') {
        this.query.balanceYear = ['', '']
      } else {
        this.query.balanceYear = ''
      }
    },
  },
  methods: {
    moment,

    getZoneData() {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)

          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    changeRadio(e) {
      this.selectDay = e.target.value
      if (this.selectDay == 'year') {
        this.selectFormat = 'YYYY'
        this.selectMode = 'year'
      } else if (this.selectDay == 'month') {
        this.selectFormat = 'YYYY-MM'
        this.selectMode = 'month'
      } else if (this.selectDay == 'quarter') {
        this.selectFormat = 'YYYY'
        this.selectMode = 'year'
      }
    },
    panelChange(value) {
      this.query.balanceYear = value
      this.open = false
    },
    openChange(status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    // 重置
    resetList() {
      this.query = {}
      this.queryList()
    },
    //更新数据
    queryList() {
      // 触发表单验证
      this.confirmLoading = true
      let params = { ...this.query }
      if (this.selectDay == 'year') {
        if (params.balanceYear && typeof params.balanceYear !== 'string') {
          params.balanceYear = params.balanceYear.format('YYYY')
        }
      } else if (this.selectDay == 'quarter') {
        if (params.balanceYear && typeof params.balanceYear !== 'string') {
          params.balanceYear = params.balanceYear.format('YYYY') + this.queryQuarter
        }
      } else if (this.selectDay == 'month') {
        if (params.balanceYear && typeof params.balanceYear !== 'string') {
          params.balanceYear = params.balanceYear.format('YYYY-MM')
        }
      } else if (this.selectDay == 'other') {
        if (params.balanceYear && typeof params.balanceYear === 'object' && params.balanceYear.length === 2) {
          params.balanceYear = params.balanceYear[0] + '~' + params.balanceYear[1]
        }
      }
      this.$http
        .get(this.url, { params })
        .then((res) => {
          if (res.code == 0) {
            this.list = res.data.list
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    panelChange(value) {
      console.log(value)
      this.query.balanceYear = value
      this.open = false
    },
    openChange(status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
      }
    },
    // 导出
    handleExport() {
      this.confirmLoading = true
      let params = { ...this.query }
      
      // 处理日期格式，与查询方法保持一致
      if (this.selectDay == 'year') {
        if (params.balanceYear && typeof params.balanceYear !== 'string') {
          params.balanceYear = params.balanceYear.format('YYYY')
        }
      } else if (this.selectDay == 'quarter') {
        if (params.balanceYear && typeof params.balanceYear !== 'string') {
          params.balanceYear = params.balanceYear.format('YYYY') + this.queryQuarter
        }
      } else if (this.selectDay == 'month') {
        if (params.balanceYear && typeof params.balanceYear !== 'string') {
          params.balanceYear = params.balanceYear.format('YYYY-MM')
        }
      } else if (this.selectDay == 'other') {
        if (params.balanceYear && typeof params.balanceYear === 'object' && params.balanceYear.length === 2) {
          params.balanceYear = params.balanceYear[0] + '~' + params.balanceYear[1]
        }
      }

      const token = storage.get(ACCESS_TOKEN)
      axios({
        url: process.env.VUE_APP_API_BASE_URL + 'pipe-network/zone_water_balances/export',
        method: 'get',
        params: params,
        responseType: 'blob',
        headers: {
          Authorization: token
        }
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '水平衡分析.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
        this.$message.success('导出成功')
      }).catch(err => {
        console.error('导出失败:', err)
        this.$message.error('导出失败')
      }).finally(() => {
        this.confirmLoading = false
      })
    },
  },
  created() {
    this.queryList()
    this.getZoneData()
  },
}
</script>

<style lang="less" scoped>
.tableCol {
  height: 40px;
}

/* 自定义table样式 */
table.gridtable {
  margin-top: 20px;
  width: 100%;
  font-size: 16px;
  /* color:#FFF; */
  border-width: 1px;
  text-align: center;
  border-color: #ffffff;
  border-collapse: collapse;
}

table.gridtable th {
  /**表头样式 */
  border-width: 1px;
  color: #fff;
  padding: 8px;
  border-style: solid;
  border-color: #888888;
  background-color: #f1f2f6;
}

table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #888888;
  background-color: #f1f2f6;
}

table.gridtable td.tableName {
  /**表格class为tableName的样式 */
  color: black;
  background-color: #f1f2f6;
  text-align: center;
  width: 200px;
  border: 1px #888888 solid;
}

table.gridtable td.tableValue {
  /**表格class为tableValue的样式 */
  background-color: #f1f2f6;
  text-align: right;
}

table.gridtable td.tableTitle {
  /**表格class为tableTitle的样式 */
  /* background-color: #F8F8F8; */
  text-align: left;
  font-weight: 400;
}

table.gridtable td.tableValue:hover {
  /**鼠标指项某一格时的样式 */
  background-color: #f1f2f6;
}

.blueFont {
  color: blue;
}
</style>
